module.exports = __webpack_public_path__ + "static/media/brego3592.818a9744.jpg";